import React from "react";
import Tr from "./tbody.tr";

class FeraTbody extends React.Component {
    render() {
        const page = Array.isArray(this.props.page) ? this.props.page : [];

        return (
            <tbody>
                {page.map((item, index) => (
                    <Tr
                        key={`tbody.tr.${index}`}
                        item={item}
                        headers={this.props.headers}
                    />
                ))}
                {page.length === 0 && (
                    <tr>
                        <td className="p-4 text-muted" colSpan={this.props.headers.length}>
                            No entries found.
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }
}

export default FeraTbody;
